import { GET_LONG_READ_POST_REQUEST, GET_LONG_READ_POST_SUCCESS, GET_LONG_READ_POST_ERROR } from '../actions/getLongReadPosts';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    isFetching: false,
    isError: false,
    data: {}
};
var initialState = {};
export function getLongReadPostsReducer(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case GET_LONG_READ_POST_REQUEST:
            // return { ...state, isFetching: true }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { isFetching: true }, initialData);
        case GET_LONG_READ_POST_SUCCESS:
            // return { ...state, isFetching: false, data: action.payload }
            return updateObjectById(state, (_c = action.payload) === null || _c === void 0 ? void 0 : _c.lgId, { isFetching: false, data: action.payload }, initialData);
        case GET_LONG_READ_POST_ERROR:
            // return { ...state, isFetching: false, isError: true }
            return updateObjectById(state, (_d = action.payload) === null || _d === void 0 ? void 0 : _d.lgId, { isFetching: false, isError: true }, initialData);
        default:
            return state;
    }
}
export function getLongreadPosts(state, lgId) {
    return state.longreadposts[lgId] || initialData;
}
//# sourceMappingURL=getLongReadPosts.js.mapimport { GET_LONG_READ_POST_REQUEST, GET_LONG_READ_POST_SUCCESS, GET_LONG_READ_POST_ERROR } from '../actions/getLongReadPosts';
import { updateObjectById } from "../utilites/newReducerHelpers";
var initialData = {
    isFetching: false,
    isError: false,
    data: {}
};
var initialState = {};
export function getLongReadPostsReducer(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initialState; }
    if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.lgId))
        return state;
    switch (action.type) {
        case GET_LONG_READ_POST_REQUEST:
            // return { ...state, isFetching: true }
            return updateObjectById(state, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.lgId, { isFetching: true }, initialData);
        case GET_LONG_READ_POST_SUCCESS:
            // return { ...state, isFetching: false, data: action.payload }
            return updateObjectById(state, (_c = action.payload) === null || _c === void 0 ? void 0 : _c.lgId, { isFetching: false, data: action.payload }, initialData);
        case GET_LONG_READ_POST_ERROR:
            // return { ...state, isFetching: false, isError: true }
            return updateObjectById(state, (_d = action.payload) === null || _d === void 0 ? void 0 : _d.lgId, { isFetching: false, isError: true }, initialData);
        default:
            return state;
    }
}
export function getLongreadPosts(state, lgId) {
    return state.longreadposts[lgId] || initialData;
}
//# sourceMappingURL=getLongReadPosts.js.map